import { render } from "./SafetyVerification.vue?vue&type=template&id=44c57374&scoped=true"
import script from "./SafetyVerification.vue?vue&type=script&lang=js"
export * from "./SafetyVerification.vue?vue&type=script&lang=js"

import "./SafetyVerification.vue?vue&type=style&index=0&id=44c57374&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c57374"]])

export default __exports__